export const baseURL = "https://carrentalgardenos.com";
export const baseUrlnoPort = "https://carrentalgardenos.com";

export const SiteSettingsApi = {
  getAllSiteSettings: `${baseURL}/site-settings/get/all`,
  updateSiteSettings: `${baseURL}/site-settings/update`,
};

export const authApi = {
  login: `${baseURL}/auth/login`,
};

export const SiteValuesApi = {
  getAllSiteValues: `${baseURL}/admin/site-values/findAll`,
  updateValue: `${baseURL}/admin/site-values/update`,
};
export const PurgeApi = {
  purge: `${baseURL}/admin/purge/`,
};

export const LocationsApi = {
  getAllLocations: `${baseURL}/admin/location/get/all`,
  setLocation: `${baseURL}/admin/location/set`,
};

export const ArticlesApi = {
  getAllArticles: `${baseURL}/admin/static-articles/get/all`,
  setArticle: `${baseURL}/admin/static-articles/set`,
};

export const TraitsApi = {
  getAllByType: `${baseURL}/admin/traits/get/all`,
  setTrait: `${baseURL}/admin/traits/set`,
  deleteTrait: `${baseURL}/admin/traits/delete`,
  getVehicleTraitInfo: `${baseURL}/admin/traits/get/information`,
};

export const VehiclesApi = {
  getAll: `${baseURL}/admin/vehicles/get/all`,
  setActivity: `${baseURL}/admin/vehicles/set/activity`,
  setVehicle: `${baseURL}/admin/vehicles/set`,
  set: `${baseURL}/admin/vehicles/set`, // this seems redundant with setVehicle
  create: `${baseURL}/admin/vehicles/create`,
};

export const ExtrasApi = {
  getAll: `${baseURL}/admin/extras/find/all`,
  set: `${baseURL}/admin/extras/set`,
  create: `${baseURL}/admin/extras/create`,
  setActivity: `${baseURL}/admin/extras/set/activity`,
};

export const InsuranceApi = {
  set: `${baseURL}/admin/insurance/set`,
  findAll: `${baseURL}/admin/insurance/find/all`,
  setIsDefault: `${baseURL}/admin/insurance/set/isDefault`,
};

export const LanguageApi = {
  findAll: `${baseURL}/admin/language/find/all`,
  create: `${baseURL}/admin/language/create`,
  delete: `${baseURL}/admin/language/delete/?`, // may be not right
};

export const ReservationApi = {
  search: `${baseURL}/admin/reservation/search`,
  completeReservation: `${baseURL}/admin/reservation/complete`,
  cancelReservation: `${baseURL}/admin/reservation/cancel`,
};
